import * as React from 'react';
import {Breadcrumb, Grid, Dropdown, Segment, Responsive} from 'semantic-ui-react';
import i18n from '../../../../locale/i18n';
import {NavLink, RouteComponentProps, withRouter} from 'react-router-dom';
import {encodeVstGrp} from './vstGrpToken';
import {
    AdditionalDataServiceComponentProps,
    ColumnSelectableComponentProps,
    ColumnSortableComponentProps, FilterObjectComponentProps,
    InfinityScrollComponentProps, withAdditionalDataServices, withColumnSelection,
    withColumnSort, withFilterObject,
    withInfinityScrollHandlers, withPrintAndExport
} from '../../components/DataTable/dataService';
import {DataTable} from '../../components/DataTable/DataTable';
import LoadingSpinner from '../../containers/LoadingContainer/LoadingSpinner';
import {ColumnDefinition} from '../../components/DataTable/common';
import ContentContainer from '../../containers/ContentContainer/ContentContainer';
import LoadingContainer from '../../containers/LoadingContainer/LoadingContainer';
import axios from 'axios';
import {SortSelectionButton} from "../../components/DataTable/SortModal";
import {DataList} from "../../components/DataTable/DataList";
import {ViewLoadingSpinner} from "../../components/ViewLoadingSpinner";
import {TranslationFunction} from "i18next";
import {withNamespaces, WithNamespaces} from "react-i18next";
import {getGroupType, GroupType} from "./common";
import {AnalyticsTracking} from "../../components/AnalyticsTracking/AnalyticsTracking";

const t = i18n.t.bind(i18n);

let paramString = "";

const COLUMNS: ColumnDefinition[] = [
    {
        fieldName: 'VerstGruppeText',
        labelTranslationKey: 'Offer.VSTGrp',
        required: true,
        headerColspan: '2',
        cellRender: (_, row, filter) => {
            return (<NavLink
                    to={`/offers/${encodeVstGrp(row.VerstGruppeText)}/${encodeURIComponent(row.ArtikelArt)}/${row.AnzahlCCGT0 + paramString}`}>
                  {row.VerstGruppeText}
                </NavLink>)},
        printExportRender: (_, row) => `${row.VerstGruppeText}`
    },
  {
    fieldName: 'none',
    labelTranslationKey: 'Offer.VSTGrpType',
    required: true,
    noHeader: true,
    cellRender: (_, row) => <GroupType articleType={row.ArtikelArt} ccGtZero={row.AnzahlCCGT0} />,
    printExportRender: (_, row) => `${getGroupType(row.ArtikelArt, row.AnzahlCCGT0, t)}`
  },
    {
        fieldName: 'gesamtWagen',
        labelTranslationKey: 'Offer.gesamtWagen',
        required: true,
        cellAlign: 'right',
        cellRender: (_, row, filter) => {
            return row.gesamtWagen;
        },
        printExportRender: (_, row) => (row.AnzahlCCGT0 > 0 ?  row.gesamtWagen :  row.anzWagenNr)
    }
];

const getScrollParent = () => ContentContainer.instance.componentRef.current;

const PageComponent = (props: WithNamespaces & RouteComponentProps & InfinityScrollComponentProps & ColumnSortableComponentProps & ColumnSelectableComponentProps & AdditionalDataServiceComponentProps & FilterObjectComponentProps) => {
  if(props.loadingInitial) {
    return <LoadingContainer showLogo={false}/>;
  }
  const {t} = props;

    paramString = props.filterObject ? "?filter=" + encodeURI(JSON.stringify(props.filterObject)) : "";

  return (
      <>
        <AnalyticsTracking page="offer_vrm" />
        <div className={"sticky-header"}>
          <div className={"ui container"}>
            <h3><Breadcrumb icon="right angle" sections={[
              {
                key: '1',
                as: NavLink,
                to: '/offers?filter=' + encodeURI(JSON.stringify(props.filterObject)),
                content: `${t("Route.Offers")}`, link: true
              }
            ]}/></h3>
            <p>{t("Common.Found$dDatasets", {count: props.totalItems})}</p> <br/>

              <Grid columns={4} className={"HeadingGrid"} stackable={true}
                    style={{marginBottom: '1em'}}>
                  <Grid.Column width={5}>
                      <Dropdown
                          placeholder={t("Offer.SelectDeliverer")}
                          selection
                          search
                          fluid
                          options={
                              props.additionalData.dailyOfferDeliverer ?
                                  props.additionalData.dailyOfferDeliverer.map(
                                      (date: any) => {
                                          return {
                                              key: date._id,
                                              text: date._id + ": " + date.AnlName,
                                              value: date._id
                                          }
                                      }
                                  ).reverse().concat([{key: "default", text:"", value:null}]).reverse()
                                  :
                                  []
                          }

                          value={props.filterObject.delivererNo || ""}

                          onChange={(_, data: any)=> {
                              props.handleFilterChange("delivererNo", data.value);
                          }}
                      />
                  </Grid.Column>
                  <Grid.Column width={5}>
                      <Dropdown
                          placeholder={t("Offer.SelectArticle")}
                          selection
                          search
                          fluid
                          options={
                              props.additionalData.dailyOfferArticles ?

                                  props.additionalData.dailyOfferArticles.map(
                                  (date: any) => {
                                      return {
                                          key: date._id,
                                          text: date._id + ": " + date.ArtikelBez,
                                          value: date._id
                                      }
                                  }
                                  ).reverse().concat([{key: "default", text:"", value:null}]).reverse()
                                  :
                                  []
                          }

                          value={props.filterObject.articleNo || ""}

                          onChange={(_, data: any)=> {
                              props.handleFilterChange("articleNo",data.value);
                          }}
                      />
                  </Grid.Column>

                  <Responsive maxWidth={960} as={Grid.Column} width={3}>
                    <SortSelectionButton
                      fluid={true}
                      availableColumns={COLUMNS}
                      currentSortColumn={props.sortColumn}
                      currentDirection={props.sortDirection}
                      onSave={props.handleSortUpdate}/>
                  </Responsive>
                <Grid.Column width={5}>
                  <Segment style={{paddingTop:"9.5px", paddingBottom: "9.5px"}}><b>Summe:</b> {props && props.data && props.data.length > 0 ? props.data[0].sum : 0}</Segment>
                </Grid.Column>
                <ViewLoadingSpinner active={props.loading} />
              </Grid>

          </div>
        </div>


        <div className={"ui container responsivewrapper"}>
          <Responsive minWidth={961}>
            <DataTable
                columns={COLUMNS}
                data={props.data}
                page={props.page}
                totalPages={props.totalPages}
                sortDirection={props.sortDirection}
                sortColumn={props.sortColumn}
                getScrollParent={getScrollParent}
                loadMore={props.loadMore}
                handleSortChange={props.handleSortChange}
                loading={props.loading}
            />
          </Responsive>
          <Responsive maxWidth={960}>
            <DataList data={props.data}
                      page={props.page}
                      totalPages={props.totalPages}
                      getScrollParent={getScrollParent}
                      loadMore={props.loadMore}
                      columns={COLUMNS}
                      renderItem={renderMobileListItem}
            />
          </Responsive>
          <div style={{opacity: props.loadingMore ? '1.0' : '0.0'}}>
            <div style={{textAlign: 'center', height: '3em', marginTop: '1.5em'}}><LoadingSpinner/>
            </div>
          </div>
          <div style={{height: '2em'}}/>
        </div>
      </>
  )
};

const renderMobileListItem = (row: any, t: TranslationFunction) => {
  return <>
    <div>
      <NavLink style={{fontWeight: 'bold'}}
               to={`/offers/${encodeVstGrp(row.VerstGruppeText)}/${encodeURIComponent(row.ArtikelArt)}/${row.AnzahlCCGT0 + paramString}`}>{row.VerstGruppeText}</NavLink>
      <div>{getGroupType(row.ArtikelArt, row.AnzahlCCGT0, t)}&nbsp;</div>
    </div>
    <div style={{textAlign: 'right', flexGrow: 1}}>
      <div style={{display: 'flex'}}>
        <div style={{textAlign: 'right', flexGrow: 1}}>{(row.AnzahlCCGT0 > 0 ?  row.gesamtWagen :  row.anzWagenNr)}&nbsp;</div>
      </div>
      <div style={{display: 'flex'}}>
        <div style={{textAlign: 'right', flexGrow: 1}}>{t('Offer.gesamtWagen')} </div>
      </div>
    </div>
  </>;
};

const dataService = {
  loadPage(page: number, sortColumn: string, sortOrder: 'ASC' | 'DESC', filter: { [p: string]: any }): Promise<any> {
    // TODO replace with RestClient because of error handling, but currently alwas calls /api/ prefix
    return axios.get('public/todays-offer',{params: {
      sortBy: sortColumn,
      sortDirection: sortOrder,
      page: page,
      count: 50,
      articleNo: filter.articleNo,
      delivererNo: filter.delivererNo,
    }});
  }
};

const PageComponentWrapped = withRouter(withAdditionalDataServices(withColumnSort(withColumnSelection(withFilterObject(withPrintAndExport(withInfinityScrollHandlers(withNamespaces()(PageComponent))))))));

export default () => (
    <PageComponentWrapped
        dataService={dataService}

        dataToLoad={{
            dailyOfferArticles: {
                "uri": "/todays-offer-articles"
            },
            dailyOfferDeliverer: {
                "uri": "/todays-offer-deliverers"
            }
        }}
        defaultSortDirection="ASC"
        defaultSortColumn="VerstGruppeText"
        printColumns={COLUMNS}
        defaultColumns={COLUMNS.map(c => c.fieldName)}
        printPath={[
          `${t("Route.Offers")}`
        ]}
    />
);
